import { GOLD_PRICE_IS_ACTIVE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export function PatchGoldPriceIsActive(data, quantityDefinition, prcieType){
  const api = `${GOLD_PRICE_IS_ACTIVE_API}detail/${quantityDefinition.id}/${prcieType}/`;
  return axiosHttp.patch(api, data);
}
